import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import * as React from 'react';

import styles from './BasicHelpSection.module.css';

const BasicHelpSection = React.memo((): React.ReactElement => {
  return (
    <section
      className={styles.section}
      data-testid="basic-help-section"
      aria-labelledby="basic-help-section-title"
    >
      <div className={styles.header}>
        <h3 className="heading-01" id="basic-help-section-title">
          Get help 24/7
        </h3>
        <p className={`body-02 ${styles.sectionParagraph}`}>
          If you&apos;re having issues or need help with CAE Connect, contact
          our 24/7 support.
        </p>

        <CobaltLink
          href={import.meta.env.VITE_HELP_HOME_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.externalLink}
        >
          help.cae.com <CobaltIconExternalLinkOutline aria-hidden="true" />
        </CobaltLink>
      </div>

      <CobaltTile className={styles.tile}>
        <div className={styles.tileContent}>
          <h3 className={`${styles.tileTitle} heading-01`}>
            My support requests
          </h3>
          <p className={`body-02 ${styles.sectionParagraph}`}>
            Create, view, and manage your existing support requests.
          </p>
        </div>

        <CobaltLink
          href={import.meta.env.VITE_HELP_MY_REQUESTS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.externalLink}
        >
          View your requests{' '}
          <CobaltIconExternalLinkOutline aria-hidden="true" />
        </CobaltLink>
      </CobaltTile>
    </section>
  );
});

BasicHelpSection.displayName = 'BasicHelpSection';

export { BasicHelpSection };
